import * as React from 'react';

import { getTableFilter } from './applicationViewTableFunctions';
import {
  usePagination,
  TableFilterV2 as TableFilter,
  useFilter,
  type DropDownSelectOption,
} from '../../../../components';
import { useGetApplicationViewFilterData } from './graphql/useGetApplicationViewFilterData';
import type {
  ApplicationViewTableFilterFields,
  FilterParamFunctions,
} from './types';

export type ApplicationViewTableFilterProps = {
  filterParamFunctions?: FilterParamFunctions;
  visibleFilterFields?: Array<keyof ApplicationViewTableFilterFields>;
  hiddenFilterFields?: Array<keyof ApplicationViewTableFilterFields>;
  onlyPaidApplicationStatusList?: boolean;
};

export const ApplicationViewTableFilter: React.FunctionComponent<
  ApplicationViewTableFilterProps
> = props => {
  const {
    visibleFilterFields,
    onlyPaidApplicationStatusList,
    hiddenFilterFields,
    filterParamFunctions,
  } = props;
  const {
    programmeChoiceMetadata,
    fundingSources,
    applicantApplyScholarships,
    gsAssigneeOption,
  } = useGetApplicationViewFilterData();
  const { filter: appliedFilter, setFilter } = useFilter();
  const { setPage } = usePagination();

  const departmentFunction = filterParamFunctions?.department;

  const {
    entryYearList,
    departments,
    prgCollabPhdPartnerList,
    rpgJoinPhdPartnerList,
  } = programmeChoiceMetadata;

  let customDepartments = departments;
  if (departmentFunction) {
    customDepartments = departmentFunction(departments);
  }

  const filters = getTableFilter(
    onlyPaidApplicationStatusList,
    entryYearList as DropDownSelectOption[],
    customDepartments,
    fundingSources,
    applicantApplyScholarships,
    prgCollabPhdPartnerList as DropDownSelectOption[],
    rpgJoinPhdPartnerList as DropDownSelectOption[],
    gsAssigneeOption,
  );

  let visibleFilters = visibleFilterFields
    ? Object.keys(filters).reduce(
        (acc: Partial<ApplicationViewTableFilterFields>, filterKey) => {
          if (
            visibleFilterFields.includes(
              filterKey as keyof ApplicationViewTableFilterFields,
            )
          ) {
            return {
              ...acc,
              [filterKey]:
                filters[filterKey as keyof ApplicationViewTableFilterFields],
            };
          } else {
            return acc;
          }
        },
        {},
      )
    : filters;

  visibleFilters = hiddenFilterFields
    ? Object.keys(visibleFilters).reduce((acc, filterKey) => {
        if (
          !hiddenFilterFields.includes(
            filterKey as keyof ApplicationViewTableFilterFields,
          )
        ) {
          return {
            ...acc,
            [filterKey]:
              visibleFilters[
                filterKey as keyof ApplicationViewTableFilterFields
              ],
          };
        } else {
          return acc;
        }
      }, {})
    : visibleFilters;

  const handleFilterChange = async (
    appliedFilter: Record<string, string | string[]>,
  ): Promise<void> => {
    await setFilter(appliedFilter);
    await setPage('1');
  };
  return (
    <TableFilter
      defaultAppliedFilter={appliedFilter}
      filters={visibleFilters}
      onFilterChange={handleFilterChange}
    />
  );
};
